<template>
  <div class="devOps_producerSpaceRole">
    <el-form ref="form" class="form_warp" inline size="mini" :model="form" label-width="100px" style="margin-top: 10px;">
      <el-form-item label="角色名称">
        <el-input :style="iptStyle" placeholder="请输入"  v-model="form.name" />
      </el-form-item>
      <el-form-item>
        <el-button  style="margin-left:32px;letter-spacing: 2px;font-weight: bold;font-size: 12px;" type="primary" @click="formSearch('reset','search')" v-if="menu.btn_role_query">查询
        </el-button>
        <el-button  style="margin-left:32px;letter-spacing: 2px;font-weight: bold;font-size: 12px;" type="primary" @click="createRole()" v-if="menu.btn_role_add">创建</el-button>
      </el-form-item>
    </el-form>
    <div style="height: 70vh">
      <el-table height="100%" :header-cell-style="getCellClass" row-key="id" ref="multipleTable" style="margin-top:0;" :cell-style="getRowClass" :data="tableData">
        <el-table-column prop="id" label="编号">
        </el-table-column>
        <el-table-column prop="name" label="角色名称">
        </el-table-column>
        <el-table-column prop="statusDesc" label="状态">
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间">
        </el-table-column>
        <el-table-column label="操作" v-if="menu.btn_role_edit">
          <template slot-scope="scope">
            <div style="display: flex;">
              <el-button type="primary" round size="mini" @click="createRole(scope.row.id)">修改</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="block devOpsSpace_page">
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                     :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="[10, 25, 50, 100]"
                     layout="total, prev, pager, next, sizes" :total="total">
      </el-pagination>
    </div>
    <Detaile  v-if="dialogVisible.update" :dialogVisible='dialogVisible.update' :hideDialogVisible="hideDialogVisible" :formInfo="checkedInfo"></Detaile>

    <el-dialog center :append-to-body="true" :title="newTitle" :visible.sync="dialogVisibleCreate" width="60%">
      <el-form :model="pSubmitForm" :rules="pSubmitRules" ref="pSubmitForm"  class="juese">
        <el-form-item label="角色名称" prop="name" >
          <el-input :style="iptStyle" placeholder="请输入" v-model="pSubmitForm.name" />
        </el-form-item>
        <el-form-item label="状态" prop="status" >
          <el-switch
              v-model="pSubmitForm.status"
              active-color="#11a983"
              inactive-color="#f5f7fa"
              active-value="1"
              inactive-value="0"
              :disabled="!chooseId">
          </el-switch>
        </el-form-item>
        <el-form-item label=""  :label-width="formLabelWidth" >
          <el-button size="small" type="primary"   :loading="loadingCreate" @click="onSubmitCreate">确 定</el-button>
          <el-button size="small" @click="dialogVisibleCreate = false">取 消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

  </div>

</template>

<script>
import {mapState} from "vuex";
import {
  getDevOpsSpaceRoleDetailApi, getDevOpsSpaceRoleListApi, postDevOpsSpaceAddRolerApi,
  postDevOpsSpaceCreateTaskApi,
  postDevopsSpaceTaskUpdateApi, postDevOpsSpaceUpdateRolerApi
} from "@/server/tops/devOps";
import {getDevOpsSpaceMenuListListApi} from "@/server/tops/base";
export default {
  components: { },
  data() {
    return {
      tableData: [],
      searchData: [],
      form:{
        user:'',
      },
      dialogVisible:{
        update: false,
      },
      checkedInfo:{},
      currentPage: 1,
      pageSize:10,
      total:0,
      // input 搜索样式
      iptStyle: {
        width: '180px'
      },

      pSubmitForm:{
        name:'',
        status: '1',
      },
      pSubmitRules:{
        name: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        status: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
      },
      dialogVisibleCreate: false,
      loadingCreate: false,
      chooseId:'',
      menu:{},
    }
  },
  async created() {
    await this.getAuth();
    await this.getNewData();
  },
  computed: {
    ...mapState(
        {
          allSelect: (state) => state.devOps.ALLSELECT,
          allMenuList: (state) => state.devOps.ALLMENULIST,
        }
    ),
    newTitle() {
      if (this.chooseId) {
        return '编辑角色';
      } else {
        return '添加角色'
      }
    },
  },
  methods: {
    getCellClass(row, column, rowIndex, columnIndex) {
      return "padding: 4px 0;height:36px;background:#7F7F7F;color:#fff;font-size:14px;"
    },
    // 表格样式
    getRowClass({ row, column, rowIndex, columnIndex }) {
      if(columnIndex == 0 || columnIndex == 1){
        return "border:none;border-top:1px solid #EBEEF5;font-size: 12px;font-weight: bold;padding:6px 0;";
      }
      return "border:none;border-top:1px solid #EBEEF5;font-size: 12px;padding:6px 0;";
    },
    createRole(id=''){
      this.dialogVisibleCreate = true;
      this.chooseId = id;
      if(this.chooseId){
        getDevOpsSpaceRoleDetailApi({id:Number(id)}).then((res)=>{
          if(res.status === 'success'){
            const ret = res.data[0] || {};
            this.pSubmitForm.name = ret.name;
            this.pSubmitForm.status = ret.status.toString();
          }
        })
      }
    },
    async getNewData(){
      let params = {}
      params.pageNo = this.currentPage
      params.pageSize = this.pageSize
      params.name = this.form.name;
      getDevOpsSpaceRoleListApi(params).then((res)=>{
        this.tableData = res.data;
        this.total = res.count;
      })
    },
    onSubmitCreate(){
      this.$refs["pSubmitForm"] .validate(async (valid) => {
        if (valid) {
          try {
            this.loadingCreate = true;
            const ret = this.chooseId ? await postDevOpsSpaceUpdateRolerApi({...this.pSubmitForm,id:Number(this.chooseId),status:Number(this.pSubmitForm.status)}) : await postDevOpsSpaceAddRolerApi({...this.pSubmitForm,status:Number(this.pSubmitForm.status)});
            this.$notify({
              message: ret.message || "数据异常",
              type: ret.status === 'success' ? 'success' : "error",
            })
            if(ret.status === 'success'){
              this.dialogVisibleCreate = false;
              this.getNewData();
            }
          } catch (error) {
            this.$notify({
              message: error || "数据异常",
              type: "error",
            })
            this.loadingCreate = false;
          } finally {
            this.loadingCreate = false;
          }
        }
      })

    },
    // 弹出模板
    async showDialogVisible(type, row) {
      this.dialogVisible[type] = true;
      this.checkedInfo = row;
    },
    async hideDialogVisible(nextStep = '', search = true) {
      for (let key in this.dialogVisible) {
        this.dialogVisible[key] = false;
      }
     // await this.getNewData();
    },
    formSearch(){
      let newTableData = [];
      this.currentPage = 1;
      this.getNewData();
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.currentPage = 1;
      this.getNewData();
    },
    handleCurrentChange(val) {
      this.getNewData();
      //this.currentPage = val
    },
    async getAuth() {
      let menu = {}
      await getDevOpsSpaceMenuListListApi().then((res) => {
        res.data.btnList.forEach((item) => {
            menu[item.code] = 1;
        })
      })
      this.menu = menu;
    },
  }
}
</script>
<style lang="scss">
.devOps_producerSpaceRole{
  .devOpsSpace_page {
    // text-align: right;
    display: flex;
    justify-content: flex-end;
    margin-right: 20px;

    .demonstration {
      font-size: 13px;
      color: #606266;
      line-height: 1;
      margin-top: 25px;
      margin-right: 10px;
    }
  }
  .el-form-item__label {
    font-weight: bold;
    font-size: 12px;
  }
}
.el-message-box__wrapper {
  bottom: initial !important;
  top:10%;
}
.juese .el-input{
  width: 56% !important;
}
.juese .el-input__inner{
  height: 32px;
  line-height: 32px;
}

.juese .el-form-item__label {
  font-weight: bold;
  font-size: 12px;
}
</style>
